import { CommonModule, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CommonSwiperComponent, NavigationEvent } from '@shared';
import { LEARNINGLAB_TAB, TabItem } from '@shared/models/tabs-constant';
import { AngularSvgIconModule } from 'angular-svg-icon';
import * as _ from 'lodash';
import { firstValueFrom } from 'rxjs';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';
// import { SwiperOptions } from 'swiper';
import { RouterStoreService } from 'thkee-common';

@UntilDestroy()
@Component({
  selector: 'app-learninglab-tab-menu',
  templateUrl: './tab-menu.component.html',
  styleUrls: ['./tab-menu.component.scss'],
  standalone: true,
  imports: [CommonModule, NgTemplateOutlet, NgFor, NgIf, RouterLink, AngularSvgIconModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LearninglabTabMenuComponent implements OnInit, AfterViewInit {
  @Input() tabItems: TabItem[] = LEARNINGLAB_TAB;
  params: any = {};
  queryParams: { preview: boolean; from: string } = {
    preview: false,
    from: '',
  };
  activeTab: string = 'overview';
  isPreviewCourse: boolean = false;

  categorySlider: SwiperOptions = {
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 1000,
    grabCursor: false,
    navigation: {
      prevEl: '.prevCtg',
      nextEl: '.nextCtg',
    },
  };

  constructor(
    private routerStore: RouterStoreService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.routerStore.getParams().subscribe((params) => {
      this.params = params;
      this.activeTab = params['tab'] ? params['tab'] : 'overview';
      if (this.activeTab) {
        //TODO: check if current tab is exist else set overview or redirect to 404
        let matchPatch = _.find(LEARNINGLAB_TAB, { route: this.activeTab });
        if (!matchPatch) {
          this.activeTab = 'overview';
        }
      }
    });
    this.innerWidth = window.innerWidth;
    this.activatedRoute.queryParams.pipe(untilDestroyed(this)).subscribe((params) => {
      if (params['preview'] === 'true') {
        this.isPreviewCourse = true;
      } else {
        this.isPreviewCourse = false;
      }
    });

    firstValueFrom(this.activatedRoute.queryParams).then((params) => {
      this.queryParams = params as { preview: boolean; from: string };
    });
  }

  getLink(tabRoute: string = '') {
    let url = ['/learning-lab', this.params.courseId];
    if (tabRoute) {
      url.push(tabRoute);
    }
    if (this.params.section) {
      url.push(this.params.section);
    }
    if (this.params.subsection) {
      url.push(this.params.subsection);
    }
    if (this.params.overviewcode) {
      url.push(this.params.overviewcode);
    }

    return url;
  }

  public innerWidth: any;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 1024 && this.activeTab === 'course-content') {
      this.router.navigate(this.getLink('overview'));
    }
  }

  @ViewChild('desireSectionPag') private desireSectionPag!: CommonSwiperComponent;

  desireCoursesNavigation!: NavigationEvent;
  desireCoursesNavigationEvent(event: NavigationEvent) {
    this.desireCoursesNavigation = event;
  }

  @ViewChild('swiperContainer', { static: true }) swiperContainer!: ElementRef<SwiperContainer>;

  ngAfterViewInit() {
    this.initializeSwiper();
  }

  private initializeSwiper() {
    const swiperElement = this.swiperContainer.nativeElement;
    swiperElement.initialize(); // Manually initialize Swiper with the config

    const swiper = this.swiperContainer.nativeElement.swiper;
    if (swiperElement) {
      Object.assign(swiper.params, this.categorySlider);
      swiperElement.initialize(); // Reinitialize swiper to apply new config
    }
  }

  changeSlide(prevOrNext: number): void {
    const swiper = this.swiperContainer.nativeElement?.swiper;
    if (swiper) {
      prevOrNext === -1 ? swiper.slidePrev() : swiper.slideNext();
    }
  }
}
